export const ReportNumber = {
  DETAILED_PLACEMENT: 1,
  TREND: 2,
  CONVERSION: 3,
  TRANSLATION: 4,
  ACTIVE_SITE: 5,
  WIDGET: 6,
  REVENUE: 7,
  TRAFFIC_PLUS: 8,
  TRANSLATOR:9,
  SPEND_ANALYSIS_REPORT:10,
  CUBOID_ANALYSIS:11

};
